import api from './api';

class AdminApi {
  static async login(username, password) {
    try {
      const response = await api.post('/admin/login', { username, password });
      if (response.data && response.data.success) {
        // Guardar credenciales codificadas en Base64 para usar en requests posteriores
        const credentials = btoa(`${username}:${password}`);
        localStorage.setItem('adminAuth', credentials);
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  static logout() {
    localStorage.removeItem('adminAuth');
  }

  static async getAllReclutamientos() {
    try {
      const credentials = localStorage.getItem('adminAuth');
      if (!credentials) {
        throw new Error('No authenticated admin session');
      }
      const response = await api.get('/admin/reclutamientos', {
        headers: {
          'Authorization': `Basic ${credentials}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  static async getReclutamientoDetalle(id) {
    try {
      const credentials = localStorage.getItem('adminAuth');
      if (!credentials) {
        throw new Error('No authenticated admin session');
      }
      const response = await api.get(`/admin/reclutamientos/${id}`, {
        headers: {
          'Authorization': `Basic ${credentials}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  static async downloadDocumento(documentoId) {
    try {
      const credentials = localStorage.getItem('adminAuth');
      if (!credentials) {
        throw new Error('No authenticated admin session');
      }
      const response = await api.get(`/admin/documentos/${documentoId}/download`, {
        responseType: 'blob',
        headers: {
          'Authorization': `Basic ${credentials}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export default AdminApi;

